export const SET_CURRENT_CUSTOMER = "SET_CURRENT_CUSTOMER";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const RESET_CUSTOMERS = "RESET_CUSTOMERS";
export const SET_CUSTOMER_LEVELS = "SET_CUSTOMER_LEVELS";
export const RESET_CURRENT_CUSTOMER = "RESET_CURRENT_CUSTOMER";
